// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2fReK","legacyBtn":"MutateMid_legacyBtn__ZweVj"};